import React from 'react'
import { useState } from 'react'
import MyModal from '../../../../UI/modal/MyModal'
import ChangeSkuForm from './ChangeSkuForm'
import EditIcon from '@mui/icons-material/Edit';
import { Tooltip } from '@mui/material'
import ValueWithEdit from '../../../../UI/table/values/ValueWithEdit';

const ChangeSkuButton = ({ supplyBillItem }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <ValueWithEdit
            value={supplyBillItem.sku}
            textTooltip={'Редагувати'}
            setOpen={setOpen}
            positionIco='left'
        />

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Редагування артикулу'}
            disableClickOutside={true}
            content={
                <ChangeSkuForm
                    supplyBillItemBd={supplyBillItem}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default ChangeSkuButton